import React from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { Dictionary } from '@domain/types/common/dictionary';
import { formatDate } from '@domain/utils/format.utils';
import { ContentArea } from '@styles/common';
import { StatDisplay } from '@screens/players/stat.display';

const roles: Dictionary<string> = {
  S: 'Super User',
  C: 'CRM',
  M: 'Moderator',
  K: 'Makoto',
  L: 'Lingua',
  R: 'Auto Reports',
  P: 'Single Reports',
  U: 'Utilities',
};

function mapRole(roleId: string) {
  return roles[roleId] || roleId;
}

const Profile = () => {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <ContentArea>
      <p>
        <StatDisplay label='Username'>{user.username}</StatDisplay>
      </p>
      <p>
        <StatDisplay label='Roles'>{user.roles && user.roles.map(mapRole).join(', ')}</StatDisplay>
      </p>
      <p>
        <StatDisplay label='Session Expiration'>{formatDate(new Date(user.expiration * 1000))}</StatDisplay>
      </p>
    </ContentArea>
  );
};

export default Profile;
